import { BUDGET_TRUSTWORTHINESS_THRESHOLD } from '@/config';

export const validateBudgetRange = (
    investment: number | null,
    minRecommended: number,
    maxRecommended: number,
) => {
    const threshold = 1 + BUDGET_TRUSTWORTHINESS_THRESHOLD;

    if (investment === null || investment === 0) {
        return { isValid: true, showWarning: false };
    }

    if (minRecommended === 0 && maxRecommended === 0) {
        return { isValid: true, showWarning: false };
    }

    const lowerBound = minRecommended / threshold;
    const upperBound = maxRecommended * threshold;

    if (investment < lowerBound || investment > upperBound) {
        return { isValid: false, showWarning: false };
    }

    if (investment < minRecommended || investment > maxRecommended) {
        return { isValid: true, showWarning: true };
    }

    return { isValid: true, showWarning: false };
};
